import { loadStripeWithRetry } from '@/utils/loadStripeWithRetry'

// QA-269: Stripe sends the customer back to return_url whatever the outcome — after an
// unfinished 3D Secure check too (status requires_action). The order may be marked as paid
// only for status succeeded; every other status keeps the payment code off the order.
export const PAYMENT_PROCESSING_MESSAGE = 'Your payment is processing.'
export const PAYMENT_NOT_COMPLETED_MESSAGE = 'Your payment was not successful, please try again.'

type ReturnQuery = Record<string, unknown>

const queryString = (value: unknown): string => (typeof value === 'string' ? value : '')

/**
 * Status of the PaymentIntent the customer came back with from Stripe.
 * The live status from Stripe (by payment_intent_client_secret) goes first; when Stripe or the
 * secret is unavailable, the redirect_status Stripe appended to return_url is used.
 * Returns null when neither is known — the caller must treat it as "not paid".
 */
export async function resolvePaymentIntentStatus(query: ReturnQuery): Promise<string | null> {
  const clientSecret = queryString(query.payment_intent_client_secret)

  if (clientSecret) {
    try {
      const stripe = await loadStripeWithRetry(import.meta.env.VITE_APP_STRIPE_KEY as string, {
        locale: 'en'
      })
      const result = await stripe?.retrievePaymentIntent(clientSecret)
      if (result?.paymentIntent?.status) {
        return result.paymentIntent.status
      }
    } catch (error) {
      console.error('[paymentIntentStatus] Failed to retrieve payment intent:', error)
    }
  }

  return queryString(query.redirect_status) || null
}
